export function setDeviceId () {
  const uuid = localStorage.getItem('device_uuid')
  if (!uuid) {
    const id = crypto.getRandomValues(new Uint32Array(1))[0].toString(32)
    localStorage.setItem('device_uuid', id)
  }
}

export function getDeviceId () {
  const uuid = localStorage.getItem('device_uuid') || undefined
  return uuid
}

export function getNow () {
  return Date.now().toString(36)
}

export function getMyId (key = 'user_id', type = 'session') {
  const device = getDeviceId() || '-'
  if (type === 'session') {
    const id = sessionStorage.getItem(key) || '-'
    return `${device}-${id.slice(-6)}`
  } else {
    const id = localStorage.getItem(key) || '-'
    return `${device}-${id}`
  }
}
